export default "__VITE_ASSET__CaDquu7i__"